import React, {CSSProperties} from 'react'
import HTMLContent from 'lib/ui/form/HTMLEditor/HTMLContent'

export default function CKEditorContent(props: {
  className?: string
  children: string
  'aria-label'?: string
  style?: CSSProperties
}) {
  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
        .html-content > p{
            padding: 0!important;
            margin: 0!important;
          }
        `,
        }}
      />

      <div style={props.style}>
        <HTMLContent
          className={props.className}
          aria-label={props['aria-label']}
        >
          {props.children}
        </HTMLContent>
      </div>
    </>
  )
}
